













export const EMPTY_THERMOCOUPLE_SETTING = Object.freeze([]);

export const applyThermocoupleSetting = (existing = [], data) => {
  if (typeof data === 'object') {
    if (existing.find((item) => item.id === data.id)) {
      return existing.map((item) => (item.id === data.id ? data : item));
    }
    return existing.concat(data);
  }
  if (typeof data === 'number') {
    return existing.filter((item) => item.id !== data);
  }
  return existing;
};
